// extracted by mini-css-extract-plugin
export default {"btnpwd":"a8490c28b4"};